import get from 'lodash.get';

const defaultValue = Object.freeze([]);

const getAvailablePlatformComponents = (rootState) =>
  get(rootState, 'user.partnerData.properties.availablePlatformComponents', defaultValue);

export default getAvailablePlatformComponents;
